import 'twin.macro'

import { ReactNode, useEffect, useState } from 'react'
import tw, { TwStyle } from 'twin.macro'

type ToggleButtonGroupProps<T extends string | number> = {
  value: T | undefined
  options:
    | Array<{
        value: T
        content: ReactNode
      }>
    | undefined
  containerStyles?: TwStyle
  btnStyle?: TwStyle
  disabled?: boolean
  onChange: (option: T) => void
}

const ToggleButtonGroup = <T extends string | number>({
  value,
  options = [],
  containerStyles,
  btnStyle,
  disabled,
  onChange
}: ToggleButtonGroupProps<T>) => {
  const [activeValue, setActiveValue] = useState<T | undefined>(value)

  useEffect(() => {
    setActiveValue(value)
  }, [value])

  return (
    <div css={[tw`flex space-x-2`, containerStyles]}>
      {options.map(option => {
        const isActive = activeValue === option.value

        return (
          <button
            key={option.value}
            disabled={disabled}
            css={[
              tw`p-3 rounded-[14px] border border-group text-main transition-colors
                disabled:cursor-not-allowed disabled:text-grey-dark disabled:border-tertiary disabled:bg-tertiary
              `,
              isActive && tw`border border-primary-middle text-primary-middle bg-toggle-button`,
              btnStyle
            ]}
            onClick={() => {
              onChange(option.value)
              setActiveValue(option.value)
            }}
          >
            {option.content}
          </button>
        )
      })}
    </div>
  )
}

export default ToggleButtonGroup
